<template>
    <div class="flex flex-col items-center" :class="containerClass">
        <div class="p-3 mx-auto text-primary bg-accent-foreground/30 rounded-full">
            <component :is="icon" :class="iconClass" />
        </div>
        <p :class="textClass">
            <slot>{{ message }}</slot>
        </p>
    </div>
</template>

<script setup>
import { Search } from 'lucide-vue-next';

const props = defineProps({
    message: {
        type: String,
        default: 'No matching records found'
    },
    icon: {
        type: [Object, String, Function],
        default: () => Search
    },
    iconClass: {
        type: String,
        default: 'h-7 w-7'
    },
    textClass: {
        type: String,
        default: 'mt-2 text-muted-foreground text-xs'
    },
    containerClass: {
        type: String,
        default: ''
    }
});
</script>
